"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIlcError = isIlcError;
exports.isError = isError;
exports.isString = isString;
exports.isStringArray = isStringArray;
function isIlcError(error) {
    const maybeIlcError = error;
    return maybeIlcError.errorId !== undefined && maybeIlcError.code !== undefined;
}
function isError(error) {
    const maybeError = error;
    return maybeError.name !== undefined && maybeError.message !== undefined;
}
function isString(value) {
    return typeof value === 'string';
}
function isStringArray(arr) {
    return Array.isArray(arr) && arr.every(isString);
}
